import { Command, Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer, NodeViewProps, NodeViewWrapper } from '@tiptap/react'

declare module '@tiptap/core' {
  interface Commands {
    video: {
      addVideos: (files: File[]) => Command
    }
  }
}

export type VideoNodeOptions = {
  inline?: boolean
  Component?: (props: NodeViewProps) => JSX.Element
}

// eslint-disable-next-line import/prefer-default-export
export const VideoNode = Node.create<VideoNodeOptions>({
  name: 'video',

  draggable: true,
  selectable: true,
  allowGapCursor: true,

  addOptions() {
    return {
      inline: false,
      Component: (props) => (
        <NodeViewWrapper data-node="video" className="video-component" contenteditable="false" data-drag-handle>
          {/* eslint-disable-next-line react/destructuring-assignment, jsx-a11y/media-has-caption */}
          <video {...props.node.attrs} />
        </NodeViewWrapper>
      ),
    }
  },

  addAttributes: () => ({
    src: { default: null },
    poster: { default: null },
    controls: { default: true },
    filename: { default: null },
  }),

  inline() {
    return this.options.inline
  },

  group() {
    return this.options.inline ? 'inline' : 'block'
  },

  parseHTML() {
    return [
      {
        tag: 'video-node',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['video-node', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(this.options.Component)
  },
})
